import axios from "axios";
import { Link } from "../host/host";

import secureLocalStorage from "react-secure-storage";
import {
  ACTING_BRANCH_HEADER,
  getActingBranch,
  stopActingAsBranch,
} from "../Utils/branchSwitch";
// The login lives in a cookie the API sets, shared by every app, so send it
// along. The server refuses cookie-only changes without X-Requested-With.
const API = axios.create({
  baseURL: Link,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});
API.interceptors.request.use((req) => {
  // Logins from before the shared cookie kept the token in storage
  const token = JSON.parse(secureLocalStorage.getItem("profile"))?.token;
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  // An Administrator switched to a branch; the server checks they may
  const actingBranch = getActingBranch();
  if (actingBranch) {
    req.headers[ACTING_BRANCH_HEADER] = actingBranch;
  }
  return req;
});

// ---- Ending the session ----------------------------------------------------
// When an admin logs this user out or suspends them (or the login expires or
// the password changes), the server answers with 401 + code SESSION_ENDED.
// Other 401s (wrong code, action not allowed...) are left to the page.
const LOGIN_PATH = "/stock/login";
let endingSession = false;

const endSession = () => {
  if (endingSession || window.location.pathname === LOGIN_PATH) return;
  endingSession = true;
  secureLocalStorage.clear();
  window.alert("Your session has ended. Please log in again.");
  // A full page load also resets the app's in-memory state
  window.location.assign(LOGIN_PATH);
};

API.interceptors.response.use(
  (response) => response,
  (error) => {
    // The right was taken away or the location removed while switched to it
    if (error.response?.data?.code === "ACTING_BRANCH_REFUSED" && getActingBranch()) {
      stopActingAsBranch();
      return Promise.reject(error);
    }
    if (
      error.response?.status === 401 &&
      error.response?.data?.code === "SESSION_ENDED" &&
      secureLocalStorage.getItem("profile")
    ) {
      endSession();
    }
    return Promise.reject(error);
  }
);

// Also check every minute and when the user returns to the tab, so someone
// who is just looking at a page is logged out too.
const SESSION_CHECK_MS = 60 * 1000;

const checkSession = () => {
  if (
    document.visibilityState !== "visible" ||
    !secureLocalStorage.getItem("profile")
  ) {
    return;
  }
  API.get("/api/v1/users/session").catch(() => {});
};

if (!window.__sessionCheckStarted) {
  window.__sessionCheckStarted = true;
  setInterval(checkSession, SESSION_CHECK_MS);
  document.addEventListener("visibilitychange", checkSession);
}

export default API;
